<template>
  <div id="app">
    <main>
      <div class="mobile-header">
        <div class="header-box" v-if="page != 'Home'">
          <a href="/">
            <img
              src="./images/renew-logo-mobile.jpg"
              alt=""
              style="width: 5em"
            />
          </a>
        </div>
        <div class="header-box">
          <i
            class="fas fa-envelope fa-2x contact-button"
            @click.prevent="contactButton()"
          ></i>
        </div>
        <div class="header-box">
          <a href="tel:5624248273">
            <i class="fas fa-phone fa-2x"></i>
          </a>
        </div>
        <div class="header-box">
          <i class="fas fa-bars fa-2x" @click.prevent="mobileMenu()"></i>
        </div>
      </div>
      <div class="top-contact-container">
        <!--  <div class="contact-top">
                <div class="black-box">
                    <div class="black-box-inner">
                        <p>CONTACT US FOR A MASTERPIECE</p>
                        <div class="big-text">ASK US HOW WE CAN BRING<br>NATURE BACK TO YOU</div>
                        <hr>
                        <p>Contact our environmentally-friendly staff today to discover the true nature of your garden’s potential. We design to enrich the environment, encourage beneficial insects to breeze right through, and for gardens to grow in blooming good health. Call (562) 424-8273 or fill out the form below today.</p>
                    </div>

                </div>
            </div> -->
        <div class="contact-flex">
          <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div class="contact-close-button" @click.prevent="closeContact()">
            X
          </div>
          <div class="contact-form">
            <div class="contact-side-image"></div>
            <div class="contact-content">
              <div v-if="!thankyou">
                <p class="contact-title">Contact</p>
                <form action="/submit" method="post">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="First Name"
                            name="name"
                            v-model="contactData.firstname"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Last Name"
                            name="last"
                            v-model="contactData.lastname"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter email"
                            name="email"
                            v-model="contactData.email"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="tel"
                            class="form-control"
                            placeholder="Phone"
                            name="phone"
                            v-model="contactData.phone"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <textarea
                            type="text"
                            class="form-control"
                            placeholder="Message"
                            name="mess"
                            v-model="contactData.mess"
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-black"
                      @click.prevent="sendContact()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
              <div v-if="thankyou">
                <p>THANK YOU!</p>
                <p>
                  Thank you for submitting a form to us and showing interest. We
                  will get back to you soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-gallery-container">
        <div
          class="modal fade"
          id="imagemodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body p-0">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  style="
                    position: absolute;
                    right: 0;
                    color: white;
                    background: black;
                  "
                >
                  <span aria-hidden="true">&times;</span
                  ><span class="sr-only">Close</span>
                </button>
                <img src="" class="imagepreview" style="width: 100%" />
              </div>
            </div>
          </div>
        </div>

        <div class="gallery-page">
          <div class="gallery-col-holder">
            <!-- <div class="gallery-top">
                        <div class="black-box">
                            <div class="black-box-inner">
                                <p>COMMERCIAL AND RESIDENTIAL INSPIRATION</p>
                                <div class="big-text">RENEWED -<br>A GALLERY OF GARDENS</div>
                                <hr>
                                <p>RENEW takes great pride in all things living. Everything is hands so your sanctuary is draped in luxuriant vegetation and blooming flowers. Take a look at what our professional groundskeepers have done for other gardens. Call us today to get started on your renewed masterpiece whether it is for commercial or personal use.</p>
                            </div>

                        </div>
                    </div> -->
            <div class="gallery col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
              <div class="filter-holder" align="center">
                <button
                  class="btn btn-default filter-button"
                  @click.prevent="filterClick('all')"
                >
                  All
                </button>
                <span style="color: white">|</span>
                <button
                  class="btn btn-default filter-button"
                  @click.prevent="filterClick('commercial')"
                >
                  Commercial
                </button>
                <span style="color: white">|</span>
                <button
                  class="btn btn-default filter-button"
                  @click.prevent="filterClick('residential')"
                >
                  Residential
                </button>
              </div>
            </div>
            <div class="gallery-col two">
              <div class="container-fluid p-0">
                <div class="row">
                  <br />

                  <div
                    v-if="showImage === true"
                    id="enlarged-image"
                    @click.prevent="closeEnlargedImage()"
                    v-html="imageToEnlarge"
                  ></div>

                  <div
                    v-for="image in images"
                    :class="
                      'gallery_product col-lg-3 col-md-3 col-sm-4 col-xs-6 col-6 filter ' +
                        image.category
                    "
                  >
                    <a
                      href="#"
                      class="pop"
                      @click.prevent="enlargeImage(image.imagename)"
                    >
                      <img
                        :src="
                          'https://admin.renewlandscapes.com/storage/gallery/' +
                            image.imagename
                        "
                        class="img-responsive w-100"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-page d-none d-lg-block">
        <div class="col-holder">
          <div
            class="home-col one clickable-col"
            @click.prevent="clickableColumn('one')"
          >
            <div class="col-label">ABOUT</div>
            <div class="black-box">
              <div class="black-box-inner">
                <p>ABOUT</p>
                <div class="big-text">
                  WHERE GREEN THUMB GOES HAND IN HAND WITH GREAT CARE
                </div>
                <hr />
                <p>
                  Whether it’s a California native garden with blue-eyed grass
                  or a winding path with boxwood hedges, RENEW combines
                  environmental science with a rich landscape design that’s
                  inspired by nature. We plan in unison with sunlight direction
                  and existing surroundings, using a variety of textures and
                  colors to create resilient landscapes that thrive with minimal
                  care. Take the time to get to know us, your plants will be
                  happy you did.
                </p>
              </div>
            </div>
          </div>

          <div
            class="home-col two clickable-col"
            @click.prevent="clickableColumn('two')"
          >
            <div class="col-label">DESIGN</div>
            <div class="black-box">
              <div class="black-box-inner">
                <p>LUSH WATER CONSERVATION DESIGNS</p>
                <div class="big-text">NOT ALL GARDENS ARE CREATED EQUALLY</div>
                <hr />
                <p>
                  All gorgeous gardens begin with a great design. Depending on
                  your taste, water-usage, and overall budget, RENEW can design,
                  plant, and maintain a great-looking garden that you can enjoy
                  for years to come. Here are just a few plans we’ve nurtured
                  into full bloom. Call us today to get started on your
                  masterpiece.
                </p>
              </div>
            </div>
          </div>
          <div class="menu-panel left">
            <div class="lines">
              <div class="line"></div>
              <div class="line" style="margin-left: 50%"></div>
            </div>
            <span
              class="menu-panel-item"
              @click.prevent="clickableColumn('one')"
              style="cursor: pointer"
              >About</span
            >
            <span
              class="menu-panel-item"
              @click.prevent="clickableColumn('two')"
              style="cursor: pointer"
              >Design</span
            >
            <span
              class="menu-panel-item"
              @click.prevent="clickableColumn('four')"
              style="cursor: pointer"
              >Services</span
            >
          </div>
          <div class="home-col three main-col">
            <p class="green-text">WE BRING NATURE HOME</p>
            <div class="menu-button" @click.prevent="menuClick()">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <img
              src="./images/renew-landscapes.jpg"
              alt=""
              class="w-100"
              @click.prevent="backHome()"
            />
            <i
              class="fas fa-envelope fa-2x green contact-button"
              @click.prevent="contactButton()"
            ></i>
            <div class="text-center">
              <p class="green-text">
                2459 Orange Ave<br />
                Signal Hill, CA 90755
              </p>
              <p class="green-text">(562) 424 8273</p>
              <a
                href="https://admin.renewlandscapes.com"
                target="_blank"
                class="green-text"
                >Admin</a
              >
            </div>
          </div>
          <div class="menu-panel right">
            <div class="lines">
              <div class="line"></div>
              <div class="line" style="margin-left: 50%"></div>
            </div>

            <span
              class="menu-panel-item"
              @click.prevent="clickableColumn('five')"
              style="cursor: pointer"
              >Difference</span
            >
            <span
              class="menu-panel-item"
              @click.prevent="showGallery()"
              style="cursor: pointer"
              >Gallery</span
            >
            <span
              class="menu-panel-item"
              @click.prevent="contactButton()"
              style="cursor: pointer"
              >Contact</span
            >
          </div>
          <div
            class="home-col four clickable-col"
            @click.prevent="clickableColumn('four')"
          >
            <div class="col-label">SERVICES</div>
            <div class="black-box">
              <div class="black-box-inner">
                <p>OUR DISTINCT SERVICES</p>
                <div class="big-text">THREE STEPS TO A WORLD OF CHANGE</div>
                <hr />
                <p>
                  To transform your garden into an ever-changing exhibition of
                  color and constant delight, RENEW has a three-step approach to
                  our distinct landscape services.
                </p>
                <p>RESEARCH, RESTORE & REGENERATE.</p>
                <p>
                  Give us thirty minutes of your time, and we’ll show you we can
                  improve your surroundings.
                </p>
              </div>
            </div>
          </div>
          <div
            class="home-col five clickable-col"
            @click.prevent="clickableColumn('five')"
          >
            <div class="col-label">DIFFERENCE</div>
            <div class="black-box">
              <div class="black-box-inner">
                <p>ALL NATURAL</p>
                <div class="big-text">
                  YOU WON’T FIND A LAWN MOWER OR LEAF BLOWER AT RENEW
                </div>
                <hr />
                <p>
                  Our ecological vision continues to grow as we change
                  conventional landscaping into how we view the relationship
                  between nature, the environment and ourselves. It starts by
                  putting an end to using power tools or plug-in equipment and
                  harmful chemicals. These methods might be the norm for most
                  gardeners, but not for RENEW.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home-page-mobile d-block d-lg-none">
        <div class="top-contact-container">
          <div class="contact-close-button">X</div>
          <div class="contact-form">
            <div class="contact-side-image"></div>
            <div class="contact-content">
              <div v-if="!thankyou">
                <p class="contact-title">Contact</p>
                <form action="/submit" method="post">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder="First Name"
                            name="name"
                            v-model="contactData.firstname"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Last Name"
                            name="last"
                            v-model="contactData.lastname"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            id="email"
                            placeholder="Enter email"
                            name="email"
                            v-model="contactData.email"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="tel"
                            class="form-control"
                            placeholder="Phone"
                            name="phone"
                            v-model="contactData.phone"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <textarea
                            type="text"
                            class="form-control"
                            id="mess"
                            placeholder="Message"
                            name="mess"
                            v-model="mess"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-black"
                      @click.prevent="sendContact()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
              <div v-if="thankyou">
                <p>THANK YOU!</p>
                <p>
                  Thank you for submitting a form to us and showing interest. We
                  will get back to you soon.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-holder">
          <div id="mobileMenu" class="mobile-menu">
            <div class="text-left panel-div">
              <span
                class="mobile-menu-panel-item"
                @click.prevent="mobileClick('one')"
                style="cursor: pointer"
                >About</span
              >
              <span
                class="mobile-menu-panel-item"
                @click.prevent="mobileClick('two')"
                style="cursor: pointer"
                >Design</span
              >
              <span
                class="mobile-menu-panel-item"
                @click.prevent="mobileClick('four')"
                style="cursor: pointer"
                >Services</span
              >
              <span
                class="mobile-menu-panel-item"
                @click.prevent="mobileClick('five')"
                style="cursor: pointer"
                >Difference</span
              >
              <span
                class="mobile-menu-panel-item"
                @click.prevent="showGallery()"
                style="cursor: pointer"
                >Gallery</span
              >
            </div>
          </div>
          <div
            class="home-col one mobile-click left"
            @click.prevent="mobileClick('one')"
            data-aos="fade-right"
          >
            <div class="col-label">ABOUT</div>
            <div class="black-box">
              <p>ABOUT</p>
              <div class="big-text">
                WHERE GREEN THUMB GOES HAND IN HAND WITH GREAT CARE
              </div>
              <hr />
              <p>
                Whether it’s a California native garden with blue-eyed grass or
                a winding path with boxwood hedges, RENEW combines environmental
                science with a rich landscape design that’s inspired by nature.
                We plan in unison with sunlight direction and existing
                surroundings, using a variety of textures and colors to create
                resilient landscapes that thrive with minimal care. Take the
                time to get to know us, your plants will be happy you did.
              </p>
            </div>
          </div>
          <div
            class="home-col two mobile-click right"
            @click.prevent="mobileClick('two')"
            data-aos="fade-left"
          >
            <div class="col-label">DESIGN</div>
            <div class="black-box">
              <p>LUSH WATER CONSERVATION DESIGNS</p>
              <div class="big-text">NOT ALL GARDENS ARE CREATED EQUALLY</div>
              <hr />
              <p>
                All gorgeous gardens begin with a great design. Depending on
                your taste, water-usage, and overall budget, RENEW can design,
                plant, and maintain a great-looking garden that you can enjoy
                for years to come. Here are just a few plans we’ve nurtured into
                full bloom. Call us today to get started on your masterpiece.
              </p>
            </div>
          </div>
          <div
            class="w-100"
            style="display: flex; flex-direction: column"
            v-if="page == 'Home'"
          >
            <div
              class="w-100 text-center big-text mt-3"
              style="font-size: 6vw"
              v-if="page == 'Home'"
            >
              WE BRING NATURE HOME
            </div>
            <img
              src="./images/renew-landscapes.jpg"
              class="mb-3"
              style="margin-left: auto; margin-right: auto; width: 50%"
              alt=""
              v-if="page == 'Home'"
            />
          </div>

          <div
            class="home-col four mobile-click left"
            @click.prevent="mobileClick('four')"
            data-aos="fade-right"
          >
            <div class="col-label">SERVICES</div>
            <div class="black-box">
              <p>OUR DISTINCT SERVICES</p>
              <div class="big-text">THREE STEPS TO A WORLD OF CHANGE</div>
              <hr />
              <p>
                To transform your garden into an ever-changing exhibition of
                color and constant delight, RENEW has a three-step approach to
                our distinct landscape services.
              </p>
              <p>RESEARCH, RESTORE & REGENERATE.</p>
              <p>
                Give us thirty minutes of your time, and we’ll show you we can
                improve your surroundings.
              </p>
            </div>
          </div>
          <div
            class="home-col five mobile-click right"
            @click.prevent="mobileClick('five')"
            data-aos="fade-left"
          >
            <div class="col-label">DIFFERENCE</div>
            <div class="black-box">
              <p>ALL NATURAL</p>
              <div class="big-text">
                YOU WON’T FIND A LAWN MOWER OR LEAF BLOWER AT RENEW
              </div>
              <hr />
              <p>
                Our ecological vision continues to grow as we change
                conventional landscaping into how we view the relationship
                between nature, the environment and ourselves. It starts by
                putting an end to using power tools or plug-in equipment and
                harmful chemicals. These methods might be the norm for most
                gardeners, but not for RENEW.
              </p>
            </div>
          </div>
        </div>
      </div>

      <router-view></router-view>

      <div
        class="footer d-none d-lg-flex"
        v-if="showFooter === true"
        style="border-bottom: none; height: unset"
      >
        <span @click.prevent="clickableColumn('one')">About</span>
        <span @click.prevent="clickableColumn('two')">Design</span>
        <span @click.prevent="clickableColumn('four')">Services</span>
        <span @click.prevent="clickableColumn('five')">Difference</span>
        <span @click.prevent="showGalleryQuick()">Gallery</span>
      </div>
      <div
        class="footer d-none d-lg-flex"
        style="border: none; height: unset; color: #7d9558"
        v-if="showFooter === true"
      >
        Copyright &copy; {{ new Date().getFullYear() }} Renew Landscapes
      </div>
      <div
        class="footer d-none d-lg-flex"
        style="border: none; height: unset; color: #7d9558"
        v-if="showFooter === true"
      >
        <a
          href="https://admin.renewlandscapes.com/"
          target="_blank"
          style="color: #7d9558"
          >Admin</a
        >
      </div>
    </main>
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.currentRouteName != "Home") {
      if (this.currentRouteName == "About") {
        this.page = "About";
        this.clickableColumn("one");
        this.mobileClick("one");
      }
      if (this.currentRouteName == "Design") {
        this.page = "Design";
        this.clickableColumn("two");
        this.mobileClick("two");
      }
      if (this.currentRouteName == "Services") {
        this.page = "Services";
        this.clickableColumn("four");
        this.mobileClick("four");
      }
      if (this.currentRouteName == "Difference") {
        this.page = "Difference";
        this.clickableColumn("five");
        this.mobileClick("five");
      }
      if (this.currentRouteName == "Gallery") {
        this.page = "Gallery";

        this.showGallery();
        var menupanels = document.getElementsByClassName("menu-panel");

        for (var i = 0; i < menupanels.length; i++) {
          menupanels[i].classList.remove("active");
        }
      }
    }
  },
  data() {
    return {
      imageToEnlarge: "",
      showImage: false,
      showFooter: false,
      images: {},
      page: "Home",
      contactData: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        mess: ""
      },
      thankyou: false
    };
  },
  methods: {
    clickableColumn: function(colNum) {
      if (colNum == "one") {
        this.$router.push({ name: "About" });
      }
      if (colNum == "two") {
        this.$router.push({ name: "Design" });
      }
      if (colNum == "four") {
        this.$router.push({ name: "Services" });
      }
      if (colNum == "five") {
        this.$router.push({ name: "Difference" });
      }
      this.showFooter = true;
      var col = document.getElementsByClassName("clickable-col " + colNum)[0];

      col.classList.add("w-100");
      col.classList.remove("w-0");
      console.log(col);

      var notCols = document.querySelectorAll(
        ".clickable-col:not(." + colNum + ")"
      );

      for (var i = 0; i < notCols.length; i++) {
        notCols[i].classList.remove("w-100");
        notCols[i].classList.add("w-0");
      }

      var colHolder = document.getElementsByClassName("col-holder")[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      var menuButton = document.getElementsByClassName("menu-button")[0];
      var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
      var menuPanelRight = document.getElementsByClassName("menu-panel")[1];

      menuPanelLeft.classList.remove("active");
      menuPanelRight.classList.remove("active");

      colHolder.classList.add("active");
      colMain.classList.add("active");
      menuButton.classList.add("active");
      var mobileMenu = document.getElementById("mobileMenu");
      mobileMenu.classList.remove("active");
    },
    menuClick: function() {
      this.$router.push({ name: "Home" });
      this.showFooter = false;
      this.showImage = false;
      this.imageToEnlarge = "";
      var colHolder = document.getElementsByClassName("col-holder")[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      var menuButton = document.getElementsByClassName("menu-button")[0];
      var colHolder2 = document.getElementsByClassName("col-holder")[1];
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      // var colMain2 = document.getElementsByClassName('main-col')[1]
      // var menuButton2 = document.getElementsByClassName('menu-button')[1]
      if (topGalleryContainer.classList.contains("active")) {
        topGalleryContainer.classList.remove("active");
        colMain.classList.remove("active");
        var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
        var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
        var menuPanelItems = document.getElementsByClassName("menu-panel-item");

        if (menuPanelLeft.classList.contains("active")) {
          menuPanelLeft.classList.remove("active");
          menuPanelRight.classList.remove("active");
          menuButton.classList.remove("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.remove("active");
          }
        } else {
          menuPanelLeft.classList.add("active");
          menuPanelRight.classList.add("active");
          menuButton.classList.add("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.add("active");
          }
        }
      }
      if (
        colHolder.classList.contains("active") ||
        colMain.classList.contains("active") ||
        colHolder2.classList.contains("active")
      ) {
        console.log("NOT getting to menu panel section");
        var clickableCol = document.getElementsByClassName("clickable-col");
        console.log(clickableCol);
        console.log(clickableCol.length);
        for (var i = 0; i < clickableCol.length; i++) {
          clickableCol[i].classList.remove("w-0");
          clickableCol[i].classList.remove("w-100");
        }
        colHolder.classList.remove("active");
        colMain.classList.remove("active");
        menuButton.classList.remove("active");
        colHolder2.classList.remove("active");
        //colMain2.classList.remove('active')
        // menuButton2.classList.remove('active')
      } else {
        console.log("getting to menu panel section");
        var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
        var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
        var menuPanelItems = document.getElementsByClassName("menu-panel-item");

        if (menuPanelLeft.classList.contains("active")) {
          menuPanelLeft.classList.remove("active");
          menuPanelRight.classList.remove("active");
          menuButton.classList.remove("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.remove("active");
          }
        } else {
          menuPanelLeft.classList.add("active");
          menuPanelRight.classList.add("active");
          menuButton.classList.add("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.add("active");
          }
        }
      }

      var topContactContainer = document.getElementsByClassName(
        "top-contact-container"
      )[0];
      if (topContactContainer.classList.contains("active")) {
        topContactContainer.classList.remove("active");
      }
    },
    backHome: function() {
      this.$router.push({ name: "Home" });
      this.showFooter = false;
      this.showImage = false;
      this.imageToEnlarge = "";
      var colHolder = document.getElementsByClassName("col-holder")[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      var menuButton = document.getElementsByClassName("menu-button")[0];
      var colHolder2 = document.getElementsByClassName("col-holder")[1];
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      menuButton.classList.remove("active");
      // var colMain2 = document.getElementsByClassName('main-col')[1]
      // var menuButton2 = document.getElementsByClassName('menu-button')[1]
      if (topGalleryContainer.classList.contains("active")) {
        topGalleryContainer.classList.remove("active");
        colMain.classList.remove("active");
        var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
        var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
        var menuPanelItems = document.getElementsByClassName("menu-panel-item");

        if (menuPanelLeft.classList.contains("active")) {
          menuPanelLeft.classList.remove("active");
          menuPanelRight.classList.remove("active");
          menuButton.classList.remove("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.remove("active");
          }
        }
      }
      if (
        colHolder.classList.contains("active") ||
        colMain.classList.contains("active") ||
        colHolder2.classList.contains("active")
      ) {
        console.log("NOT getting to menu panel section");
        var clickableCol = document.getElementsByClassName("clickable-col");
        console.log(clickableCol);
        console.log(clickableCol.length);
        for (var i = 0; i < clickableCol.length; i++) {
          clickableCol[i].classList.remove("w-0");
          clickableCol[i].classList.remove("w-100");
        }
        colHolder.classList.remove("active");
        colMain.classList.remove("active");
        menuButton.classList.remove("active");
        colHolder2.classList.remove("active");
        //colMain2.classList.remove('active')
        // menuButton2.classList.remove('active')
      } else {
        console.log("getting to menu panel section");
        var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
        var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
        var menuPanelItems = document.getElementsByClassName("menu-panel-item");

        if (menuPanelLeft.classList.contains("active")) {
          menuPanelLeft.classList.remove("active");
          menuPanelRight.classList.remove("active");
          menuButton.classList.remove("active");
          for (var i = 0; i < menuPanelItems.length; i++) {
            menuPanelItems[i].classList.remove("active");
          }
        }
      }
      var col = document.getElementsByClassName("mobile-click");
      for (var i = 0; i < col.length; i++) {
        col[i].classList.remove("h-100");
        col[i].classList.remove("h-0");
        col[i].classList.remove("leaver");
      }

      var topContactContainer = document.getElementsByClassName(
        "top-contact-container"
      )[0];
      if (topContactContainer.classList.contains("active")) {
        topContactContainer.classList.remove("active");
      }
    },
    contactButton: function() {
      var topContactContainer = document.getElementsByClassName(
        "top-contact-container"
      )[0];
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      this.showImage = false;
      this.imageToEnlarge = "";
      if (topContactContainer.classList.contains("active")) {
        topContactContainer.classList.remove("active");
        var clickableCols = document.getElementsByClassName("clickable-col");
        var doesHave = 0;
        for (var i = 0; i < clickableCols.length; i++) {
          if (clickableCols[i].classList.contains("w-100")) {
            doesHave = 1;
          }
        }
        if (doesHave == 0) {
          colMain.classList.remove("active");
        }
      } else {
        topContactContainer.classList.add("active");
        topGalleryContainer.classList.remove("active");
        colMain.classList.add("active");
      }
    },
    closeContact: function() {
      var topContactContainer = document.getElementsByClassName(
        "top-contact-container"
      )[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      this.showImage = false;
      this.imageToEnlarge = "";
      if (topContactContainer.classList.contains("active")) {
        topContactContainer.classList.remove("active");
        var clickableCols = document.getElementsByClassName("clickable-col");
        var doesHave = 0;
        for (var i = 0; i < clickableCols.length; i++) {
          if (clickableCols[i].classList.contains("w-100")) {
            doesHave = 1;
          }
        }
        if (doesHave == 0) {
          colMain.classList.remove("active");
        }
      } else {
        topContactContainer.classList.add("active");
        this.$router.go(-1);
      }
    },
    mobileMenu: function() {
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      topGalleryContainer.classList.remove("active");
      this.$router.push({ name: "Home" });
      var col = document.getElementsByClassName("mobile-click");
      for (var i = 0; i < col.length; i++) {
        col[i].classList.remove("h-100");
        col[i].classList.remove("h-0");
        col[i].classList.remove("leaver");
      }

      var mobileMenu = document.getElementById("mobileMenu");
      mobileMenu.classList.toggle("active");
      var menuPanelItems = document.getElementsByClassName(
        "mobile-menu-panel-item"
      );
      if (mobileMenu.classList.contains("active")) {
        for (var i = 0; i < menuPanelItems.length; i++) {
          menuPanelItems[i].classList.add("active");
        }
      } else {
        for (var i = 0; i < menuPanelItems.length; i++) {
          menuPanelItems[i].classList.remove("active");
        }
      }
    },
    showGalleryQuick: function() {
      this.$router.push({ name: "Gallery" });
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
      var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
      var menuPanelItems = document.getElementsByClassName("menu-panel-item");

      colMain.classList.add("active");

      if (topGalleryContainer.classList.contains("active")) {
        topGalleryContainer.classList.remove("active");
        colMain.classList.remove("active");
      } else {
        topGalleryContainer.classList.add("active");
        colMain.classList.add("active");
      }
      var mobileMenu = document.getElementById("mobileMenu");
      mobileMenu.classList.remove("active");
    },
    showGallery: function() {
      this.$router.push({ name: "Gallery" });
      this.getGallery();
      var topGalleryContainer = document.getElementsByClassName(
        "top-gallery-container"
      )[0];
      var colMain = document.getElementsByClassName("main-col")[0];
      var menuPanelLeft = document.getElementsByClassName("menu-panel")[0];
      var menuPanelRight = document.getElementsByClassName("menu-panel")[1];
      var menuPanelItems = document.getElementsByClassName("menu-panel-item");

      colMain.classList.add("active");
      if (menuPanelLeft.classList.contains("active")) {
        menuPanelLeft.classList.remove("active");
        menuPanelRight.classList.remove("active");
        for (var i = 0; i < menuPanelItems.length; i++) {
          menuPanelItems[i].classList.remove("active");
        }
      } else {
        menuPanelLeft.classList.add("active");
        menuPanelRight.classList.add("active");
        for (var i = 0; i < menuPanelItems.length; i++) {
          menuPanelItems[i].classList.add("active");
        }
      }
      if (topGalleryContainer.classList.contains("active")) {
        topGalleryContainer.classList.remove("active");
        colMain.classList.remove("active");
      } else {
        topGalleryContainer.classList.add("active");
        colMain.classList.add("active");
      }
      var mobileMenu = document.getElementById("mobileMenu");
      mobileMenu.classList.remove("active");
    },
    mobileClick: function(colNum) {
      if (colNum == "one") {
        this.$router.push({ name: "About" });
      }
      if (colNum == "two") {
        this.$router.push({ name: "Design" });
      }
      if (colNum == "four") {
        this.$router.push({ name: "Services" });
      }
      if (colNum == "five") {
        this.$router.push({ name: "Difference" });
      }
      var col = document.getElementsByClassName("mobile-click " + colNum)[0];

      col.classList.add("h-100");
      col.classList.remove("h-0");

      var notCols = document.querySelectorAll(
        ".mobile-click:not(." + colNum + ")"
      );

      for (var i = 0; i < notCols.length; i++) {
        notCols[i].classList.remove("h-100");
      }
      for (var i = 0; i < notCols.length; i++) {
        notCols[i].classList.add("leaver");
      }
      setTimeout(function() {
        for (var i = 0; i < notCols.length; i++) {
          notCols[i].classList.add("h-0");
        }
      }, 300);

      var mobileMenu = document.getElementById("mobileMenu");
      mobileMenu.classList.remove("active");
    },
    filterClick: function(val) {
      if (val == "all") {
        var filterEl = document.getElementsByClassName("filter");
        for (var i = 0; i < filterEl.length; i++) {
          filterEl[i].style.display = "block";
        }
      } else {
        var filterEl = document.getElementsByClassName("filter");
        for (var i = 0; i < filterEl.length; i++) {
          filterEl[i].style.display = "block";
        }
        var notCols = document.querySelectorAll(".filter:not(." + val + ")");

        for (var i = 0; i < notCols.length; i++) {
          notCols[i].style.display = "none";
        }
        // Array.prototype.filter.call(document.querySelectorAll('.filter'), '.'+val).style.display = 'block'
      }
    },
    enlargeImage: function(fileName) {
      this.imageToEnlarge =
        '<img src="https://admin.renewlandscapes.com/storage/gallery/' +
        fileName +
        '" class="img-responsive w-100">';
      this.showImage = true;
    },
    closeEnlargedImage: function() {
      this.showImage = false;
      this.imageToEnlarge = "";
    },
    getGallery: function() {
      axios
        .get("https://admin.renewlandscapes.com/api/get/images")
        .then(response => {
          console.log(response);
          this.images = response.data;
          this.isLoading = false;
        });
    },
    sendContact: function() {
      axios
        .post("https://admin.renewlandscapes.com/api/submit-contact", {
          contactData: this.contactData,
          headers: {
            "content-type": "application/json",
            "X-CSRF-TOKEN": document.head.querySelector(
              "meta[name='csrf-token']"
            ).content
          }
        })
        .then(response => {
          console.log(response);
          this.isLoading = false;
          this.thankyou = true;
        });
    }
  },
  computed: {
    currentRouteName: function() {
      return this.$route.name;
    }
  },
  watch: {
    $route(to, from) {
      console.log("to " + to["name"]);
      console.log("from " + from);
      this.page = to["name"];
      if (to["name"] == "About") {
        console.log("working");
        this.clickableColumn("one");
        this.mobileClick("one");
      }
      if (to["name"] == "Design") {
        console.log("working");
        this.clickableColumn("two");
        this.mobileClick("two");
      }
      if (to["name"] == "Services") {
        console.log("working");
        this.clickableColumn("four");
        this.mobileClick("four");
      }
      if (to["name"] == "Difference") {
        console.log("working");
        this.clickableColumn("five");
        this.mobileClick("five");
      }
      //              if(to['name'] == 'Gallery') {
      //
      //                  this.showGalleryQuick()
      //                  var menupanels = document.getElementsByClassName('menu-panel')
      //
      //                  for(var i=0; i < menupanels.length; i++) {
      //                      menupanels[i].classList.remove('active')
      //
      //                  }
      //              }

      if (to["name"] == "Home") {
        //                  window.location.href = '/'
        //                  location.reload()
        console.log("initial load WRONG");
        this.backHome();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue